<template>
<el-col :span="24" class="keep">
  <div class="task">
    <div class="taskdetail">
      <div class="taskbox">
        <div class="left">
          <div class="leftIcon">
            <span class="ico ico-cart icolist"></span>
          </div>
        </div>
        <div class="left">
          <div class="leftIcon">
            <span class="ico ico-shop icolist"></span>
          </div>
        </div>
        <div class="left">
          <div class="leftIcon">
            <span class="ico ico-task icolist"></span>
          </div>
        </div>
      </div>
      <div class="textbox">
        <div class="taskboxright">
          <div class="right">
            <div class="taskTitle">发布下单任务</div>
            <div class="taskContant">小程序挑选商品或通过底部发布按钮填写商品详情发布代下单任务。</div>
          </div>
          <div class="right">
            <div class="taskTitle">买手接单并去商家下单</div>
            <div class="taskContant">认证买手在海外官网下单，提供下单/发货凭证，物流全程跟踪。</div>
          </div>
        </div>
        <div class="taskboxrightend">
          <div class="right">
            <div class="taskTitle">确认任务完成</div>
            <div class="taskContant">您在收货后，确认任务完成，买手收到您支付的金额。</div>
            <a class="taskLink" href="/HelpCenter">进一步了解</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</el-col>
</template>

<script>
export default {
  name: 'Task',
  components: {},
  data() {
    return {
      search: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.keep {
    margin: 20px auto;
}
.task {
    width: 100%;
    .taskdetail {
        max-width: 800px;
        margin: -48px auto;
        .textbox {
            .taskboxright {
                height: 240px;
                margin-left: 40px;
                border-left: 2px dashed #dee1eb !important;
            }
        }
        .taskbox {
            margin: 0 auto;
            height: 360px;
            width: 40px;
            float: left;
            .left {
                float: left;
                width: 80px;
                height: 120px;
                .leftIcon {
                    margin: 1px auto;
                    width: 37px;
                    height: 37px;
                    border-radius: 50%;
                    background-color: black;
                    .icolist {
                        margin: 6px;
                    }
                }
            }
        }
    }
    .taskboxrightend {
        height: 120px;
        margin-left: 40px;
    }

    .right {
        height: 120px;
        margin-left: 80px;
        .taskTitle {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 8px;

            font-family: PingFangSC-Regular;
            color: rgba(51, 51, 51, 1);
            line-height: 27px;
        }

        .taskContant {
            font-size: 16px;
            font-family: PingFangSC-Regular;
            color: rgba(102, 102, 102, 1);
            line-height: 26px;

            margin-bottom: 20px;
            word-break: break-all;
            word-wrap: break-word;

        }

        .taskLink {
            font-size: 14px;
            font-family: PingFangSC-Regular;
            color: rgba(15, 102, 207, 1);
            line-height: 20px;
        }
    }

}

@media screen and (max-width: 1024px) {
    .task {
        .taskdetail {
            margin: 0px auto;
        }
        .right {
            margin-left: 40px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Task.vue